import { http_get } from './helpers';
import { version } from './config';
import { BrandCard, Brand } from './types';

// /api/v{version}/m/Brand
/**
 * 获取品牌列表
 */
export const getBrandList = http_get<
    {
        name?: string;
        sorting?: string;
        skipCount?: number;
        maxResultCount?: number;
    },
    {
        totalCount: number;
        items: BrandCard[];
    }
>(`/api/v${version}/m/Brand`);

// /api/v{version}/m/Brand/{id}
// 获取品牌详情
export const getBrand = http_get<
    {
        id: number;
    },
    Brand
>(`/api/v${version}/m/Brand/{id}`);
